<template>
  <div>
    <h3 style="margin-bottom: 20px">Entity Choices</h3>
    <el-row>
      <!-- <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="User can add new data"
          placement="right"
        >
          <el-checkbox v-model="field.allow_quick_add">
            <span> Allow to add new data </span>
          </el-checkbox>
        </el-tooltip>
      </el-col> -->
      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="If an entity has only one piece of data, it will be selected."
          placement="left"
        >
          <el-checkbox v-model="field.auto_select_one_data">
            Auto select if entity has only 1 data
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="User can select multiple options"
          placement="right"
        >
          <el-checkbox
            :disabled="checkEntityVariable"
            v-model="field.allow_multiple"
          >
            Allow multiple data
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" v-if="field.allow_multiple" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="All entity options will be auto selected"
          placement="right"
        >
          <el-checkbox v-model="field.auto_complete"> Auto fill </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="Entity selection will be shown as a link. Users can click it to view detailed entity data, including data table rows."
          placement="right"
        >
          <el-checkbox v-model="field.detailed_view">
            Show as detailed view link
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" v-if="field.detailed_view" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="In detailed we get only entity data not data tables rows"
          placement="right"
        >
          <el-checkbox v-model="field.show_only_totals">
            Show only totals
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="Include an ALL option to select all entity options at once."
          placement="right"
        >
          <el-checkbox v-model="field.show_all_option">
            Show ALL option
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="From this, we can show an alert when there is no data."
          placement="right"
          >{{ shouldShowCheckbox }}
          <el-checkbox
            v-if="shouldShowCheckbox"
            v-model="field.show_alert_entity"
          >
            <span> Display an alert if there is no data available </span>
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="18">
        <div
          class="input-container"
          v-if="field.show_alert_entity && shouldShowCheckbox"
          style="margin-bottom: 10px; display: flex; align-items: center"
        >
          <span> Alert Message: </span>
          <el-input
            v-model="field.alert_message_store"
            placeholder="Enter your message"
            style="flex: 1"
          ></el-input>
        </div>
      </el-col>

      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="Getting entity data and auto-selecting, etc., will also execute in view mode."
          placement="right"
        >
          <el-checkbox v-model="field.always_execute">
            Always Execute
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <el-col :span="12" class="checkbox-col" v-if="!field.detailed_view">
        <el-tooltip
          effect="dark"
          content="it shows count only."
          placement="right"
        >
          <el-checkbox v-model="field.show_count"> Show Count </el-checkbox>
        </el-tooltip>
        <el-col>
          <el-radio-group
            v-model="field.show_count_type"
            v-if="field.show_count"
          >
            <el-radio label="count">Count</el-radio>
            <el-radio label="sum">Sum</el-radio>
            <el-radio label="average">Average</el-radio>
          </el-radio-group>
        </el-col>
        <div
          v-if="
            (field.show_count_type == 'sum' ||
              field.show_count_type == 'average') &&
            field.show_count
          "
          :span="12"
          style="margin-top: 30px"
        >
          <el-tooltip
            effect="dark"
            content="Select a number field to display sum or average."
            placement="right"
          >
            <el-select
              v-model="field.count_field"
              size="mini"
              placeholder="Select Number field"
              clearable
            >
              <template
                v-for="(option, index) in getSelectedEntityCountFields([
                  'NUMBER',
                  'CURRENCY',
                  'AGGREGATE_FUNCTION',
                  'FORMULA',
                ])"
              >
                <el-option
                  :value="option.template_id + '#' + option.key"
                  :label="option.label"
                  :key="index + '_field_ase'"
                >
                  <span style="float: left">{{ option.label }}</span>
                </el-option>
              </template>
            </el-select>
          </el-tooltip>
        </div>
      </el-col>
      <el-col :span="12" class="checkbox-col">
        <div style="col-align">
          <label>Sort data by</label>
          <el-select
            v-model="field.entity_sort"
            size="mini"
            placeholder="Sorting order"
            clearable
          >
            <template
              v-for="(option, index) in getSelectedEntityCountFields([
                'DATE',
                'NUMBER',
                'CURRENCY',
                'SELECT',
              ])"
            >
              <el-option
                :value="'asc/' + option.template_id + '#' + option.key"
                :label="option.label"
                :key="index + '_field_ase'"
              >
                <span style="float: left">{{ option.label }}</span>
                <span style="float: right">Asc</span>
              </el-option>
              <el-option
                :value="'des/' + option.template_id + '#' + option.key"
                :label="option.label"
                :key="index + '_field_dis'"
              >
                <span style="float: left">{{ option.label }}</span>
                <span style="float: right">Des</span>
              </el-option>
            </template>
          </el-select>
        </div>
      </el-col>
      <el-col :span="12" v-if="field.show_count" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="In the detailed link, you can view the count."
          placement="right"
        >
          <el-checkbox v-model="field.detailed_view_count">
            Show count in detailed view link
          </el-checkbox>
        </el-tooltip>
      </el-col>
      <!-- <el-row> -->
      <el-col :span="12" class="checkbox-col">
        <el-tooltip
          effect="dark"
          content="Check to enable custom search input; uncheck to use the dropdown options."
          placement="left"
        >
          <el-checkbox v-model="field.search_mode_enabled">
            Enable Search Mode
          </el-checkbox>
        </el-tooltip>
        <el-checkbox
          v-if="field.search_mode_enabled"
          v-model="field.customizeSearchButton"
        >
          Customize button
        </el-checkbox>
        <el-button
          v-if="field.search_mode_enabled && field.customizeSearchButton"
          style="padding: 10px; margin-left: 20px"
          class="primary"
          @click="buttonCustomizeModal = true"
        >
          customize
        </el-button>
      </el-col>
      <el-col :span="12" class="checkbox-col">
        <el-checkbox v-model="field.enable_sortData"
          >Sort Data by Order</el-checkbox
        >
        <el-select
          v-if="field.enable_sortData"
          v-model="field.sortDataOrder"
          placeholder="Select Order"
        >
          <el-option
            v-for="option in sortOptions"
            :key="option.key"
            :label="option.label"
            :value="option.value"
          />
        </el-select>
      </el-col>

      <!-- </el-row> -->

      <!-- <el-col :span="12" class="checkbox-col">
        <div>
          <label>Select primary fields</label>
          <el-select
            v-model="field.primary_fields"
            no-data-text="Primary fields"
            filterable
            default-first-option
            multiple
            collapse-tags
          >
            <el-option
              v-for="(entity, index) of allEntityFields || []"
              :value="entity.key"
              :key="index + '' + entity.key"
              :label="entity.label"
            >
              <span style="float: left">{{ entity.label }}</span>
            </el-option>
          </el-select>
        </div>
      </el-col> -->
      <el-col :span="24" style="margin-top: 20px" class="checkbox-col">
        <h2>Entity Filters</h2>
        <EntityFilters :field="field" :fieldsData="fieldsData"></EntityFilters>
      </el-col>
    </el-row>
    <dialog-component
      append-to-body
      :title="'Customize your button'"
      :visible="buttonCustomizeModal"
      @before-close="buttonCustomizeModal = false"
      :containerWidth="'50%'"
      :isShowFooter="false"
    >
      <div>
        <ButtonCustomize
          :initialProps="field.SearchButtonConfigs"
          v-on:saveButtonConfigs="saveSearchModeButtonConfigs"
        />
      </div>
    </dialog-component>
  </div>
</template>

<script>
export default {
  name: "templates-formComponents-Entity-advanced-settings",
  props: ["field", "fieldsData", "allEntityFields"],
  data() {
    return {
      openFiltersDialogComponent: false,
      show_alert_entity: false,
      buttonCustomizeModal: false,
      sortOptions: [
        { key: "asc", value: "asc", label: "Ascending" },
        { key: "desc", value: "desc", label: "Descending" },
      ],
    };
  },
  mounted() {},
  components: {
    EntityFilters: () => import("./EntityFilters"),
    ButtonCustomize: () => import("./CustomizeButton.vue"),
  },
  computed: {
    shouldShowCheckbox() {
      return (this.field.filters || []).find((filter) => {
        if (
          filter.data_source == "self_field" ||
          filter.data_source == "TEMPLATE"
        ) {
          return true;
        }
      })
        ? true
        : false;
    },
    checkEntityVariable() {
      if (this.fieldsData && this.fieldsData.length > 0) {
        let variables = this.fieldsData.filter(
          (e) =>
            e.relationship_key == this.field.key && e.inputType != "DATA_TABLE"
        );
        return variables.length ? true : false;
      }
      return false;
    },
  },
  methods: {
    getSelectedEntityCountFields(types) {
      let newFields = JSON.parse(JSON.stringify(this.allEntityFields));
      return (newFields || [])
        .filter(
          (e) =>
            types.indexOf(e.inputType) != -1 ||
            (e.inputType == "FORMULA" && types.indexOf(e.result_type) != -1) ||
            (e.inputType == "AGGREGATE_FUNCTION" &&
              (types.indexOf("NUMBER") != -1 ||
                types.indexOf("CURRENCY") != -1))
        )
        .map((e) => {
          if (e?.key && e.key.includes("#")) {
            e.key = e.key.split("#")[1];
          }
          return e;
        });
    },
    openFilterModel() {
      this.openFiltersDialogComponent = true;
    },
    saveSearchModeButtonConfigs(configs) {
      this.field["SearchButtonConfigs"] = {
        ...configs,
      };
      this.buttonCustomizeModal = false;
    },
    closeFiltersDialogComponent() {
      this.openFiltersDialogComponent = false;
    },
  },
};
</script>

<style lang="scss">
.col-align {
  display: flex;
  flex-direction: column !important;
}
.checkbox-col {
  margin-bottom: 10px; // Adjust the value as needed for the desired gap
}
</style>
